import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ShippingService {
    constructor(private http: HttpClient) { }

    getAllVendors() {
        return this.http.get<any>(`${environment.vendorUrl}Vendor`);
    }

    getAllVendorsByCategoryId(id) {
        return this.http.get<any>(
            `${environment.vendorUrl}Vendor/AllVendorsByCategory?categoryId=${id}`
        );
    }

    getAllCategory() {
        return this.http.get<any>(`${environment.vendorUrl}Category`);
    }

    getVendorRegistrationByOrganization(id) {
        return this.http.get<any>(
            `${environment.vendorUrl}VendorOAuthRegistration/VendorOAuthRegistrationByOrganization?vendorId=${id}`
        );
    }

    checkVendorInstallation(id) {
        return this.http.get<any>(
            `${environment.vendorUrl}Vendor/OrganizationVendorInstalled?vendorId=${id}`
        );
    }

    deletePackBox(id) {
        return this.http.delete<any>(`${environment.vendorUrl}PackBox/${id}`);
    }

    addPackBox(data) {
        return this.http.post<any>(`${environment.vendorUrl}PackBox`, data);
    }

    updatePackBox(data) {
        return this.http.put<any>(`${environment.vendorUrl}PackBox`, data);
    }

    addVendorRegistration(data) {
        return this.http.post<any>(
            `${environment.vendorUrl}VendorOAuthRegistration`,
            data
        );
    }

    updateVendorRegistration(data) {
        return this.http.put<any>(
            `${environment.vendorUrl}VendorOAuthRegistration`,
            data
        );
    }

    deleteVendor(id) {
        return this.http.delete<any>(
            `${environment.vendorUrl}VendorOAuthRegistration/${id}`
        );
    }

    installFedexOrUps(vendorId) {
        return this.http.post<any>(
            `${environment.vendorUrl}FedEx/InstallVendor?vendorID=${vendorId}`,
            {}
        );
    }

    uninstallFedexOrUps(vendorId) {
        return this.http.delete<any>(
            `${environment.vendorUrl}FedEx/UninstallVendor?vendorID=${vendorId}`
        );
    }

    getVendorOAuthRegistrationByUser(id) {
        return this.http.get<any>(
            `${environment.vendorUrl}VendorOAuthRegistrationUser/${id}`
        );
    }

    getFedexAccessToken(encStr) {
        return this.http.get<any>(
            `${environment.vendorUrl}FedEx/AccessToken?state=${encStr}`
        );
    }

    upsValidateClient(encStr) {
        return this.http.get<any>(
            `${environment.vendorUrl}UPS/ValidateClient?state=${encStr}`
        );
    }

    getUpsAccessToken(authToken, id, encStr) {
        return this.http.get<any>(
            `${environment.vendorUrl}UPS/AccessToken?authCode=${authToken}&vendorId=${id}&state=${encStr}`
        );
    }

    saveFedexIsProdAndAddressVerifyInfo(isProd, verifyAddress, id) {
        return this.http.post<any>(
            `${environment.vendorUrl}FedEx/SaveIsProdAddressVerify?isProd=${isProd}&addressVerification=${verifyAddress}&vendorId=${id}`,
            {}
        );
    }

    saveUpsIsProdAndAddressVerifyInfo(isProd, verifyAddress, id) {
        return this.http.post<any>(
            `${environment.vendorUrl}FedEx/SaveIsProdAddressVerify?isProd=${isProd}&addressVerification=${verifyAddress}&vendorId=${id}`,
            {}
        );
    }

    saveFedexAccountInfo(isProduction, accDetailsObjEncStr, addressObjEncStr, vendorId) {
        return this.http.post<any>(
            `${environment.vendorUrl}FedEx/SaveCustomerAccount?accountDetails=${accDetailsObjEncStr}&address=${addressObjEncStr}&isProduction=${isProduction}&vendorId=${vendorId}`,
            {}
        );
    }

    getUpsSignInUrl(url) {
        return this.http.get<any>(`${url}`);
    }

    // fedex address
    getAllStates(countryId: number) {
        return this.http
            .get<any>(`${environment.coreUrl}State`, {
                params: new HttpParams().append(
                    "countryId",
                    countryId.toString()
                ),
            })
            .toPromise()
            .then((res) => res);
    }

    addState(data: object) {
        return this.http
            .post<any>(`${environment.coreUrl}State`, data)
            .toPromise()
            .then((res) => res);
    }

    getAllCities(stateId) {
        return this.http
            .get<any>(`${environment.coreUrl}City`, {
                params: new HttpParams().append("stateId", stateId.toString()),
            })
            .toPromise()
            .then((res) => res);
    }

    addCity(data: object) {
        return this.http
            .post<any>(`${environment.coreUrl}City`, data)
            .toPromise()
            .then((res) => res);
    }

    getCountry() {
        return this.http.get<any>(`${environment.coreUrl}Country`);
    }

    getAddressTypes() {
        return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
    }

    getFedexAccounts(organizationId, vendorId) {
        return this.http.get<any>(
            `${environment.vendorUrl}FedEx/GetAccountsDetail?organisationID=${organizationId}&vendorID=${vendorId}`
        );
    }

    getFedexIsProdAddressVerify(vendorId) {
        return this.http.get<any>(
            `${environment.vendorUrl}FedEx/GetIsProdAddressVerify?vendorId=${vendorId}`
        );
    }

    getUpsIsProdAddressVerify(vendorId) {
        return this.http.get<any>(
            `${environment.vendorUrl}FedEx/GetIsProdAddressVerify?vendorId=${vendorId}`
        );
    }

    saveFedexDefaultAccount(accNo, vendorId) {
        return this.http.post<any>(
            `${environment.vendorUrl}FedEx/SaveIsDefault?accountNumber=${accNo}&vendorID=${vendorId}`,
            {}
        );
    }

    // updateFedexProductionAccount(accNo, vendorId, obj) {
    //     return this.http.put<any>(
    //         `${environment.vendorUrl}VendorOAuthRegistrationUser?accountNumber=${accNo}&vendorID=${vendorId}`,
    //         obj
    //     );
    // }

    deleteAccount(id){
        return this.http.delete<any>(
            `${environment.vendorUrl}VendorOAuthRegistrationUser/${id}`
        );
    }
}
